export enum FundsUnmatchedReason {
    BuyerNotFound = 'buyer-not-found',
    ChargeNotFound = 'charge-not-found',
    ChargeCanceled = 'charge-canceled',
    CheckoutNotFound = 'checkout-not-found',
    TransactionNotFound = 'transaction-not-found',
    PaymentMethodNotFound = 'payment-method-not-found',
    MultipleBuyersFound = 'multiple-buyers-found',
    MultipleCheckoutsFound = 'multiple-checkouts-found',
    InternalErrorDuringFundsMatching = 'internal-error-during-funds-matching',
    InternalErrorDuringFundsAllocation = 'internal-error-during-funds-allocation',
    SuitableCheckoutOrInvoiceNotFound = 'suitable-checkout-or-invoice-not-found',
    BuyerNameIsMissing = 'buyer-name-is-missing',
}
